<template>
  <div
    style="
      position: absolute;
      left: -28px;
      bottom: -16px;
      width: 54px;
      height: 54px;
      transform: rotate(-45deg);
      border: 2px solid var(--primary-color);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <div
      style="
        background-color: #bcbcbe;
        min-height: 75px;
        min-width: 76px;
        transform: rotate(45deg);
      "
    />
  </div>
</template>
